// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__18fe3","head":"ProcedureTableInfo_head__3veup"};